import styled from 'styled-components';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import { Typography } from '@mui/material';
import { FlexColumn } from '../../Flex';
import IconButton from '../../IconButton';

const Container = styled(FlexColumn)`
  align-items: center;
  gap: 12px;
  padding: 16px;
  margin: 16px 0;
`;

const MessageText = styled(Typography)`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.text.secondary};
  text-align: center;
  line-height: 1;
`;

const ContinueButton = styled(IconButton)`
  border: 1px solid ${({ theme }) => theme.palette.common.gray5} !important;
  background: ${({ theme }) => theme.palette.common.white} !important;
  padding: 8px 16px;
  gap: 8px;

  :hover {
    background: ${({ theme }) => theme.palette.common.gray8} !important;
    border-color: ${({ theme }) => theme.palette.common.gray5} !important;
  }
`;

type Props = {
  onContinue: () => void;
  disabled?: boolean;
};

const StuckMessage = ({ onContinue, disabled = false }: Props) => (
  <Container>
    <MessageText>
      There&apos;s a connection issue.
      <br />
      <br />
      Try continuing again in a couple of moments.
    </MessageText>
    <ContinueButton
      onClick={onContinue}
      disabled={disabled}
      variant="outlined"
      aria-label="Retry conversation"
    >
      <RefreshRoundedIcon sx={{ fontSize: '20px', color: 'text.secondary' }} />
      <Typography sx={{ color: 'text.secondary' }}>Retry</Typography>
    </ContinueButton>
  </Container>
);

export default StuckMessage;
